export const getConversationListWidth = ({
  isDesktop,
  isTablet,
}: {
  isDesktop: boolean;
  isTablet: boolean;
}): string => {
  if (isDesktop) return '388px';
  if (isTablet) return '300px';
  return '100%';
};
